import { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "What is a Traffic Management Plan (TMP)?",
    a: "A Traffic Management Plan is a document that outlines how traffic, pedestrians and cyclists will be safely managed around a work site or event. It includes diagrams, sign layouts, procedures and risk assessments, and is usually required before council or authority approval is granted.",
  },
  {
    q: "How quickly can you turn around a traffic management plan?",
    a: "In most cases we can deliver a completed plan within 24 hours of receiving the necessary project information. For larger or more complex projects we will advise you of the expected timeframe upfront.",
  },
  {
    q: "Which states do you operate in?",
    a: "We service all eight Australian states and territories — NSW, VIC, QLD, WA, SA, TAS, NT and ACT — including metro, regional and rural areas.",
  },
  {
    q: "Do you handle council and authority submissions?",
    a: "Yes. We can prepare and submit your TMP, Traffic Guidance Scheme (TGS), road occupancy licence or event permit directly to the relevant authority on your behalf, managing the approval process from start to finish.",
  },
  {
    q: "What is a Traffic Guidance Scheme (TGS)?",
    a: "A TGS is a detailed diagram showing sign placement, delineation and lane configurations for a specific work site. It is usually required alongside a TMP and must comply with the relevant Australian Standard (AS 1742.3).",
  },
  {
    q: "Do you provide on-site traffic controllers?",
    a: "Yes. We can supply qualified, certified traffic controllers for construction zones, events and road maintenance works anywhere across New South Wales.",
  },
  {
    q: "What information do you need to prepare a plan?",
    a: "We typically need the site address, scope of works, expected duration, any existing council or authority requirements, and an idea of the traffic volumes and road type involved. The more detail you can provide the faster we can turn it around.",
  },
  {
    q: "How much does a traffic management plan cost?",
    a: "Pricing depends on the complexity and scope of the project. Contact us for a no-obligation quote and we will provide a fixed price before any work begins.",
  },
  {
    q: "Are your plans compliant with Australian Standards?",
    a: "Yes. All plans are prepared in accordance with the relevant Australian Standards, state-specific guidelines (including TfNSW requirements) and local council specifications.",
  },
  {
    q: "Can you help with urgent or after-hours requests?",
    a: "Absolutely. We offer 24/7 support and can accommodate urgent requests. Simply call us on 1300 118 170 and we will do our best to assist you immediately.",
  },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-gray-100 last:border-0">
      <button
        type="button"
        className="flex w-full items-start justify-between gap-4 py-5 text-left"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span className="text-[15px] font-semibold text-gray-900">{q}</span>
        <span
          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gray-200 text-gray-400 transition-transform ${
            open ? "rotate-45 border-orange-400 text-orange-500" : ""
          }`}
        >
          <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
          </svg>
        </span>
      </button>
      {open && (
        <p className="pb-5 text-sm leading-relaxed text-gray-500">{a}</p>
      )}
    </div>
  );
}

export default function FAQ() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="border-b border-gray-100 bg-gray-50 px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-orange-500">
            Got questions?
          </p>
          <h1 className="text-3xl font-extrabold tracking-tight text-black sm:text-4xl lg:text-5xl">
            Frequently Asked Questions
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-gray-500">
            Everything you need to know about our traffic management
            services. Can&apos;t find what you&apos;re looking for?{" "}
            <Link to="/contact" className="font-medium text-orange-500 underline">
              Get in touch.
            </Link>
          </p>
        </div>
      </div>

      {/* FAQ list */}
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-gray-200 bg-white px-6 shadow-sm sm:px-8">
          {faqs.map((item) => (
            <FaqItem key={item.q} q={item.q} a={item.a} />
          ))}
        </div>


      </div>
    </div>
  );
}
